/**
  * CONFLUENCE FORMAT FIELDS RULES
  https://speedlab.atlassian.net/wiki/spaces/PMI/pages/50036737/FORMAT+FIELDS+RULES
*/
const patterns: any = {
  /* eslint-disable */
  alphaWithBlankspace: /^[a-zA-Z\s]+$/,
  N4_6: /^(?!0|$)[\d]{1,6}$|^(?=.*[1-9].*)(?=.{1,7}$)\d*(\.\d{1,4})$/,
  N4_8: /^(?!0|$)[\d]{1,8}$|^(?=.*[1-9].*)(?=.{1,9}$)\d*(\.\d{1,4})$/,
  N4_9: /^(?!0|$)[\d]{1,9}$|^(?=.*[1-9].*)(?=.{1,10}$)\d*(\.\d{1,4})$/,
  R1_8: /^(?!0|$)[\d]{1,8}$|^(?=.*[1-9].*)(?=.{1,9}$)\d*(\.\d+)$/,
  R1_9: /^(?!0|$)[\d]{1,9}$|^(?=.*[1-9].*)(?=.{1,10}$)\d*(\.\d+)$/,
  // TODO: the following R1_8_4, R1_9_4 are the same as N45_8, N45_9
  // need to clarify it
  // R1/8 & max decimal places = 4
  // R1/9 & max decimal places = 4
  R1_8_4: /^(?:\d{1,8}|(?=.*[1-9].*)(?!.{10})\d+\.\d{1,4})$/,
  R1_9_4: /^(?:\d{1,9}|(?=.*[1-9].*)(?!.{11})\d+\.\d{1,4})$/,
  alphaNumerical: /^[a-zA-Z0-9]+$/,
  alphaNumericalDashes: /^[a-zA-Z0-9-]+$/,
  alphaNumericalBlankspace: /^[a-zA-Z0-9\s]+$/,
  ANdescriptions: /^[^\[\]~|^\\*]+$/,
  ANpartNumber: /^[a-zA-Z0-9/.-\s]+$/,
  ANpriceSheetNumber: /^[a-zA-Z0-9{},"!$?'/.-\s]+$/,
  ANbarCode: /^[a-zA-Z0-9/.-]+$/,
  filename: /^[^\\/:*"'<>|#%]+$/,
  anyURI: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
  /* eslint-enable */
};

export default patterns;
